import { ContactGroup } from '@app/core/interfaces/c5/contact-group';
import { PhoneBookContact } from '@app/core/interfaces/c5/phone-book-contact';
import { noop } from '@app/utils/common';
import { FormMapping } from '@app/utils/form-mapping/decorators/form-mapping';
import { FormMappingAttribute } from '@app/utils/form-mapping/decorators/form-mapping-attribute';
import { Required, StringInput } from '@app/utils/form-mapping/helpers/default-attributes';
import { FormMappingModel } from '@app/utils/form-mapping/models/form-mapping-model';

@FormMapping()
export class ContactGroupFormModel extends FormMappingModel {
  @FormMappingAttribute({
    defaultValue: [],
    mergeFunction: (model: ContactGroup, contacts: PhoneBookContact[]) => {
      model.entries = contacts.map((contact) => ({
        abId: contact.id,
      }));
    },
    parseFunction: noop,
    selector: 'entries',
  })
  contacts: PhoneBookContact[];

  @Required
  @StringInput
  name: string;
}
